import React from 'react';
import PropTypes from 'prop-types';

import './ActivitySpinner.scss';

class ActivitySpinner extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    size: PropTypes.number,
  }

  static defaultProps = {
    className: '',
    isActive: true,
    size: 5,
  };

  render() {
    let className = 'aa-activity-spinner';
    className += this.props.isActive ? '' : ' hidden';
    className += this.props.className ? ` ${this.props.className}` : '';

    if (this.props.isActive) {
      return (<div className={className} style={{ fontSize: `${this.props.size}px` }} />);
    }
    return (<div className={className} />);
  }
}

export default ActivitySpinner;
